import { useAccessToken } from '@/features/auth/state/auth'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL
const api = axios.create({ baseURL: BASE_URL })

export function sendCodeFromEmail() {
  const queryClient = useQueryClient()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ empresa, to, code }: { empresa: string; to: string; code: string }) => {
      if (!token) throw new Error('Usuário não autenticado')
      let body
      if (empresa === 'localhost' || !empresa) {
        body = {
          empresa: 'klingerconsults',
          to,
          code
        }
      } else {
        body = {
          empresa,
          to,
          code
        }
      }
      console.log(body)
      const response = await api.post(`/mail/send-code`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })
      // return true
      if (response.data) {
        return response.data
      } else {
        throw new Error(`Erro ao enviar mensagem ${body}`)
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mail'] })
    }
  })
}

export function sendOwnerVerificationLinkFromEmail() {
  const queryClient = useQueryClient()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ empresa, to, document }: { empresa: string; to: string; document: string }) => {
      const body = {
        empresa: empresa === 'localhost' || !empresa ? 'klingerconsults' : empresa,
        to,
        document
      }

      const headers = token ? { Authorization: `Bearer ${token}` } : undefined
      const response = await api.post(`/mail/send-owner-verification-link`, body, { headers })

      if (response.data) {
        return response.data
      }

      throw new Error(`Erro ao enviar link de confirmação para ${to}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mail'] })
    }
  })
}

type SendWhatsAppArgs = {
  empresa: string
  whatsapp: string
  code: string
}

export function useSendCodeFromWhatsApp() {
  const queryClient = useQueryClient()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ empresa, whatsapp, code }: SendWhatsAppArgs) => {
      if (!token) throw new Error('Usuário não autenticado')
      let name = ``
      console.log(`empresa`, empresa)
      if (empresa === 'localhost' || !empresa) {
        empresa = 'klingerconsults'
      } else if (empresa === 'trinsolution' || !empresa) {
        name = 'Trinsolution'
      } else if (empresa === 'klingerconsults' || !empresa) {
        name = 'Klinger Consults'
      // } else if (empresa === 'grupobahiasul' || !empresa) {
      //   name = 'Grupo Bahia Sul'
      } else if (empresa === 'dsconsultoriat' || !empresa) {
        name = 'DS Consultoria'
      // } else if (empresa === 'mdtributaria' || !empresa) {
      //   name = 'MD Tributaria'
      }
      const texto = `Olá, Codigo para conferir o WhatsApp da ${name}: ${code}`
      const options = {
        method: 'POST',
        headers: {
          apikey: 'cb835ca4097db739e555e728d9d00747',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          number: `55${whatsapp}`,
          text: texto
        })
      }

      const response = await fetch(`https://api1.abatisolucoes.com.br/message/sendText/${empresa}`, options)
      const data = await response.json()
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['wpp'] })
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: ['wpp'] })
    }
  })
}
